import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DataConnection, Workflow } from '@nimmsta/ng-commons-lib/models';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { DataConnectionService } from '../../../services/dataConnection.service';
import { TranslatePipe } from '@ngx-translate/core';
import { LaddaModule } from 'angular2-ladda';

@Component({
  selector: 'app-weclapp',
  templateUrl: './weclapp.component.html',
  imports: [TranslatePipe, ErrorComponent, LaddaModule, TranslatePipe],
})
export class WeclappComponent {
  modalRef = inject(DynamicDialogRef);
  private readonly dialogConfig = inject(
    DynamicDialogConfig<{
      dataConnection?: DataConnection;
      workflow?: Workflow;
    }>,
  );
  private dataConnectionService = inject(DataConnectionService);

  dataConnection = this.dialogConfig.data?.dataConnection;

  workflow = this.dialogConfig.data?.workflow;

  loading = false;

  error?: HttpErrorResponse;

  execute() {
    this.loading = true;
    this.dataConnectionService.execute(this.dataConnection!).subscribe({
      next: () => {
        this.loading = false;
        this.modalRef.close();
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.error = err;
      },
    });
  }

  getUrl(): string {
    if (this.dataConnection && this.dataConnection.configuration) {
      return this.dataConnection.configuration.url || '';
    } else {
      return '';
    }
  }
}
